import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    display: 'flex',
    justifyContent: 'space-between',
    py: '2',
    pl: '3',
    pr: '2',
    borderBottomWidth: '1px',
    borderBottomColor: 'beta.500',
    bg: 'alpha.700',
    fontWeight: 'bold',
    _hover: {
      textDecoration: 'none',
    },
  },
  textCompetitionName: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
  },
  textMatchCount: {
    color: 'white',
    px: '1',
  },
};
